// import components
import { Box, styled } from '@mui/material';

export const StyledBaseQueueBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  margin: theme.spacing(3, 0),
  alignItems: 'flex-end'
}));
